import React, { Component } from 'react';

export default class CustomNumericCellEditor extends Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
  }

  onKeyDown(event) {
  if (event.keyCode !== 8 && event.keyCode !== 13) {
    if (event.keyCode === 39 || event.keyCode === 37) {
      event.stopPropagation();
    }

    if (!isNumeric(event.nativeEvent)) {
      event.preventDefault();
    }

    function isNumeric(event) {
      return /^[\d.,]+$/.test(event.key);
    }
  }
}

  afterGuiAttached() {
    if (this.textInput) this.textInput.current.focus();
  };

  getValue() {
    return this.textInput.current.value;
  };

  render() {
    return (
      <input type='number' style={{transform: 'translateY(-14px)'}} onKeyDown={this.onKeyDown} ref={this.textInput} defaultValue={this.props.value}/>
    );
  }
}